import {useExecutionsQuery} from './useExecutionsQuery';
import {useExecutionsTableColumns} from './useExecutionsTableColumns';

export const useExecutions = (filters: Record<string, string> = {}) => {
    const {data: items = [], isLoading: loading} = useExecutionsQuery(filters);
    const {columns} = useExecutionsTableColumns();

    return {
        items: items ?? [],
        visibleItems: items ?? [],
        loading,
        columns,
    };
};
